"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var getMoveToMruList_1 = require("./actions/getMoveToMruList");
exports.getMoveToMruList = getMoveToMruList_1.default;
owa_bundling_1.preloadScriptChunk('MoveMruActions');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "MoveMruActions" */ './lazyIndex');
});
exports.lazyAddFolderIdToMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.addFolderIdToMoveToMruList; });
exports.lazyRemoveFolderIdFromMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFolderIdFromMoveToMruList; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/index.js
// module id = 1840
// module chunks = 23 62 105 108